import { Pipe, PipeTransform, inject } from '@angular/core';
import { PhoneNumber } from '@sc/data-access-models';
import { PhoneNumberDisplayContext } from '../models';
import { PhoneNumberDisplayService } from '../services';

@Pipe({
  name: 'phoneNumber',
  pure: true,
  standalone: true,
})
export class PhoneNumberPipe implements PipeTransform {
  private readonly phoneNumberDisplayService = inject(
    PhoneNumberDisplayService
  );

  transform(
    phone: PhoneNumber | string,
    overrideContext?: PhoneNumberDisplayContext,
    additionnalInfos?: any
  ) {
    return this.phoneNumberDisplayService.getPhoneNumberTranslation(
      phone,
      overrideContext,
      additionnalInfos
    );
  }
}
